/* BrilloMotor — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveals al hacer scroll + cifras animadas (un solo observer) */
  function initReveal() {
    var els = document.querySelectorAll('.bm-reveal:not(.bm-visible), [data-bm-count]:not([data-bm-done]), .bm-cta:not(.bm-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('bm-visible'); if (el.hasAttribute('data-bm-count')) finishCount(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('bm-visible');
        if (el.hasAttribute('data-bm-count')) countUp(el);
        io.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function finishCount(el) {
    el.setAttribute('data-bm-done', '');
    el.textContent = el.getAttribute('data-bm-count');
  }
  function countUp(el) {
    var raw = el.getAttribute('data-bm-count');
    var target = parseFloat(raw.replace(',', '.'));
    if (isNaN(target)) return finishCount(el);
    var decimals = (raw.split(/[.,]/)[1] || '').length;
    var sep = raw.indexOf(',') > -1 ? ',' : '.';
    var dur = parseInt(el.getAttribute('data-bm-duration') || '1600', 10);
    var start = null;
    el.setAttribute('data-bm-done', '');
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(decimals).replace('.', sep);
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }

  /* Parallax suave en el hero */
  function initParallax() {
    if (reduce) return;
    var items = document.querySelectorAll('[data-bm-parallax]');
    if (!items.length) return;
    var ticking = false;
    function update() {
      items.forEach(function (img) {
        var k = parseFloat(img.getAttribute('data-bm-parallax')) || 0;
        var rect = img.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        img.style.transform = 'translate3d(0,' + (-rect.top * k / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Página de producto */
  function initProducto() {
    document.querySelectorAll('[data-bm-product]').forEach(function (root) {
      if (root.dataset.bmReady) return;
      root.dataset.bmReady = '1';
      var dataEl = root.querySelector('[data-bm-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = root.querySelector('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var priceEl = root.querySelector('[data-bm-price]');
      var compareEl = root.querySelector('[data-bm-compare]');
      var saveEl = root.querySelector('[data-bm-save]');
      var btn = root.querySelector('[data-bm-add]');
      var btnText = btn ? btn.querySelector('span') : null;
      var errorEl = root.querySelector('[data-bm-error]');
      var sticky = document.querySelector('[data-bm-sticky-buy]');

      /* Galería */
      var main = root.querySelector('[data-bm-main]');
      var videoBox = root.querySelector('[data-bm-video]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-bm-thumb]'));
      var current = 0;
      function stopVideo() {
        if (!videoBox || videoBox.hidden) return;
        videoBox.innerHTML = ''; videoBox.hidden = true;
        if (main) main.style.visibility = '';
      }
      function playVideo(t) {
        if (!videoBox) return false;
        var el;
        if (t.dataset.video) {
          el = document.createElement('video');
          el.src = t.dataset.video; el.controls = true; el.autoplay = true; el.muted = true; el.loop = true;
          el.setAttribute('playsinline', ''); el.poster = t.dataset.src;
        } else if (t.dataset.embed) {
          el = document.createElement('iframe');
          el.src = t.dataset.embed; el.allow = 'autoplay; encrypted-media; picture-in-picture'; el.allowFullscreen = true;
          el.title = t.dataset.alt || 'Vídeo';
        } else return false;
        videoBox.innerHTML = ''; videoBox.appendChild(el); videoBox.hidden = false;
        if (main) main.style.visibility = 'hidden';
        return true;
      }
      function show(i) {
        if (!main || !thumbs.length) return;
        current = (i + thumbs.length) % thumbs.length;
        var t = thumbs[current];
        thumbs.forEach(function (x, n) { x.setAttribute('aria-current', n === current ? 'true' : 'false'); });
        if (t.dataset.video || t.dataset.embed) { if (playVideo(t)) return; }
        stopVideo();
        main.classList.add('bm-fading');
        setTimeout(function () {
          main.src = t.dataset.src;
          main.srcset = t.dataset.srcset || '';
          main.alt = t.dataset.alt || '';
          main.classList.remove('bm-fading');
        }, 180);
      }
      thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
      var prev = root.querySelector('[data-bm-prev]');
      var next = root.querySelector('[data-bm-next]');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      if (main) {
        var x0 = null;
        main.parentElement.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.parentElement.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      /* Variantes */
      var fieldsets = root.querySelectorAll('[data-bm-option]');
      function selected() {
        return Array.prototype.map.call(fieldsets, function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      function find(opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { ok = false; break; }
          if (ok) return v;
        }
        return null;
      }
      function markAvailability(opts) {
        fieldsets.forEach(function (fs, idx) {
          fs.querySelectorAll('input').forEach(function (inp) {
            var test = opts.slice(); test[idx] = inp.value;
            var v = find(test);
            var lab = inp.nextElementSibling;
            if (lab) lab.classList.toggle('bm-unavailable', !v || !v.available);
          });
        });
      }
      function update() {
        var opts = selected();
        var v = find(opts);
        markAvailability(opts);
        fieldsets.forEach(function (fs, idx) {
          var b = fs.querySelector('legend b');
          var c = fs.querySelector('input:checked');
          if (b && c) b.textContent = c.nextElementSibling.dataset.label || c.value;
        });
        if (!btn) return;
        if (!v) {
          btn.disabled = true; if (btnText) btnText.textContent = btn.dataset.unavailable;
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = v.price;
        if (compareEl) { compareEl.innerHTML = v.compare || ''; compareEl.hidden = !v.compare; }
        if (saveEl) { saveEl.textContent = v.save || ''; saveEl.hidden = !v.save; }
        document.querySelectorAll('[data-bm-sticky-price]').forEach(function (el) { el.innerHTML = v.price; });
        btn.disabled = !v.available;
        if (btnText) btnText.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
        if (v.media) {
          var idx = thumbs.findIndex(function (t) { return t.dataset.media === String(v.media); });
          if (idx > -1 && idx !== current) show(idx);
        }
        if (window.history && window.history.replaceState && root.dataset.url) {
          window.history.replaceState({}, '', root.dataset.url + '?variant=' + v.id);
        }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
      if (fieldsets.length) {
        var initOpts = selected();
        markAvailability(initOpts);
      }

      /* Cantidad */
      var qty = root.querySelector('[data-bm-qty]');
      if (qty) {
        root.querySelectorAll('[data-bm-qty-btn]').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(qty.value, 10) || 1;
            qty.value = Math.max(1, n + parseInt(b.dataset.bmQtyBtn, 10));
          });
        });
      }

      /* Añadir al carrito y abrir el carrito lateral de Dawn */
      if (form && window.fetch) {
        form.addEventListener('submit', function (e) {
          var drawer = document.querySelector('cart-drawer');
          var notif = document.querySelector('cart-notification');
          var cart = drawer || notif;
          if (!cart || typeof cart.renderContents !== 'function') return; // envío normal a /cart
          e.preventDefault();
          if (errorEl) errorEl.textContent = '';
          btn.disabled = true; btn.setAttribute('aria-busy', 'true');
          var fd = new FormData(form);
          var sections = cart.getSectionsToRender().map(function (s) { return s.id; });
          var addons = Array.prototype.filter.call(form.querySelectorAll('[data-bm-addon]'), function (c) { return c.checked; });
          var body = fd, headers = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' };
          if (addons.length) {
            /* Producto + complementos marcados en una sola llamada */
            var items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }];
            addons.forEach(function (c) { items.push({ id: Number(c.value), quantity: 1 }); });
            body = JSON.stringify({ items: items, sections: sections.join(','), sections_url: window.location.pathname });
            headers['Content-Type'] = 'application/json';
          } else {
            fd.append('sections', sections.join(','));
            fd.append('sections_url', window.location.pathname);
          }
          fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST', headers: headers, body: body
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) {
              if (errorEl) errorEl.textContent = res.description || res.message || 'No se ha podido añadir.';
              return;
            }
            if (res.items && res.items.length && !res.key) { res.id = res.items[0].id; res.key = res.items[0].key; }
            addons.forEach(function (c) { c.checked = false; });
            if (drawer && drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            cart.renderContents(res);
          }).catch(function () { form.submit(); })
            .finally(function () { btn.removeAttribute('aria-busy'); var v = find(selected()); btn.disabled = v ? !v.available : !fieldsets.length ? false : true; });
        });
      }

      /* Barra de compra fija */
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('bm-show', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(btn);
        var sBtn = sticky.querySelector('button');
        if (sBtn) sBtn.addEventListener('click', function () {
          if (btn.disabled) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          btn.click();
        });
      }
    });
  }


  /* Traducción al español de los textos de Judge.me (reseñas) */
  var BM_JDGM = {
    'Customer Reviews': 'Opiniones de clientes',
    'Be the first to write a review': 'Sé el primero en dejar tu opinión',
    'Write a review': 'Escribir una reseña',
    'Write a Review': 'Escribir una reseña',
    'Write a Reseña': 'Escribir una reseña',
    'No reviews': 'Sin reseñas',
    'How would you rate this product?': '¿Qué puntuación le das a este producto?',
    'We would love it if you would share a bit about your experience.': 'Nos encantaría que nos contaras tu experiencia.',
    'Review content (Required)': 'Tu reseña (obligatorio)',
    "We'll only contact you about your review if necessary. By submitting your review, you agree to our": 'Solo te contactaremos sobre tu reseña si es necesario. Al enviarla, aceptas nuestros',
    'terms and conditions': 'términos y condiciones',
    'and': 'y',
    'privacy policy': 'política de privacidad',
    'About you': 'Sobre ti',
    'Please tell us more about you.': 'Cuéntanos un poco sobre ti.',
    'Email address (Required)': 'Correo electrónico (obligatorio)',
    'We respect your privacy.': 'Respetamos tu privacidad.',
    'Display name (Required)': 'Nombre visible (obligatorio)',
    "This won't be visible to other customers.": 'Los demás clientes no lo verán.',
    'Post review as anonymous': 'Publicar la reseña de forma anónima',
    'Share a picture or video': 'Comparte una foto o un vídeo',
    'Upload a photo or video to support your review.': 'Sube una foto o un vídeo para acompañar tu reseña.',
    'Click to upload': 'Pulsa para subir',
    'or drag and drop': 'o arrástralo aquí',
    'YouTube URL': 'Enlace de YouTube',
    'Back': 'Atrás',
    'Next': 'Siguiente',
    'Submit': 'Enviar',
    'Submit Review': 'Enviar reseña',
    'Thanks for your review!': '¡Gracias por tu reseña!',
    'We are processing it and it will appear on the store soon.': 'La estamos revisando y aparecerá en la tienda en breve.',
    'Please confirm your email by clicking the link we just sent you. This helps us keep reviews authentic.': 'Confirma tu correo con el enlace que te acabamos de enviar. Así mantenemos las reseñas auténticas.',
    'Would you like to share your experience of shopping with us?': '¿Quieres contarnos qué tal ha sido tu experiencia de compra?',
    'We value your feedback and use it to improve. Please share any thoughts or suggestions you have.': 'Tu opinión nos ayuda a mejorar. Compártenos cualquier comentario o sugerencia.',
    'Close': 'Cerrar',
    'Poor': 'Mala',
    'Fair': 'Regular',
    'Average': 'Normal',
    'Good': 'Buena',
    'Great': 'Excelente',
    'Very poor': 'Muy mala',
    'Excellent': 'Excelente',
    'Required': 'Obligatorio',
    'Name': 'Nombre',
    'Email': 'Correo electrónico',
    'Review Title': 'Título de la reseña',
    'Rating': 'Puntuación',
    'Most Recent': 'Más recientes',
    'Highest Rating': 'Mejor valoradas',
    'Lowest Rating': 'Peor valoradas',
    'Only Pictures': 'Solo con fotos',
    'Most Helpful': 'Más útiles',
    'Verified': 'Verificada',
    'Verified Buyer': 'Compra verificada',
    'Was this review helpful?': '¿Te ha resultado útil?',
    'Load More Reviews': 'Ver más reseñas',
    'Start writing here...': 'Empieza a escribir aquí...',
    'Your email address': 'Tu correo electrónico',
    'Display name': 'Nombre visible',
    'Paste your Youtube URL here': 'Pega aquí el enlace de YouTube'
  };
  function bmTraducirJdgm(root) {
    if (!root || !root.querySelectorAll) return;
    var zonas = root.matches && root.matches('[class*="jdgm"], [class*="jm-"]') ? [root] : root.querySelectorAll('.jdgm-widget, .jdgm-review-widget, [class*="jdgm-write-review"], .jdgm-prev-badge, [class*="jm-"]');
    Array.prototype.forEach.call(zonas, function (z) {
      var w = document.createTreeWalker(z, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        var t = n.textContent.replace(/\s+/g, ' ').trim();
        if (!t) continue;
        if (BM_JDGM[t]) { n.textContent = n.textContent.replace(n.textContent.trim(), BM_JDGM[t]); continue; }
        var m = t.match(/^(\d+) reviews?$/i);
        if (m) n.textContent = m[1] + (m[1] === '1' ? ' reseña' : ' reseñas');
        else if (/^Based on (\d+) reviews?$/i.test(t)) n.textContent = t.replace(/^Based on (\d+) reviews?$/i, function (_, k) { return 'Basado en ' + k + (k === '1' ? ' reseña' : ' reseñas'); });
      }
      z.querySelectorAll('[placeholder]').forEach(function (e) { var ph = e.getAttribute('placeholder'); if (BM_JDGM[ph]) e.setAttribute('placeholder', BM_JDGM[ph]); });
    });
  }
  function initJdgmEs() {
    bmTraducirJdgm(document.body);
    if (!('MutationObserver' in window) || document.body.dataset.bmJdgm) return;
    document.body.dataset.bmJdgm = '1';
    var pend = false;
    new MutationObserver(function () {
      if (pend) return; pend = true;
      requestAnimationFrame(function () { pend = false; bmTraducirJdgm(document.body); });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function init() { initReveal(); initParallax(); initProducto(); initJdgmEs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
